import { DiagnosisItem } from "../../diagnosis.model";
import { Tooth } from "../../../../odontogram/odontogram.model";
import { AbstractCondition } from "../condition";

export class Other extends AbstractCondition {
  static validate(
    item: DiagnosisItem,
    odontogram: Tooth[],
    items: DiagnosisItem[],
  ): boolean {
    // validate name
    if (!item.options.name) {
      return false;
    }

    return true;
  }

  static supports(condition: string): boolean {
    return condition === "other";
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/conditions/other/other.ts